import { render, staticRenderFns } from "./Pluggto.vue?vue&type=template&id=bd4a5520"
import script from "./Pluggto.vue?vue&type=script&lang=js"
export * from "./Pluggto.vue?vue&type=script&lang=js"
import style0 from "./Pluggto.vue?vue&type=style&index=0&id=bd4a5520&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports